import { useGetRequest } from "@ch/api/useGetRequest.ts";
import { ProgramsControllerService } from "@ch/generated";

function useGetProgramById(programId = "") {
  const { data: program, loading } = useGetRequest({
    service: ProgramsControllerService.programsControllerGetProgramById,
    tag: "ProgramsControllerService",
    enabled: !!programId,
    payload: {
      id: programId,
    },
  });

  return {
    program,
    loading,
  };
}

export default useGetProgramById;
